// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu {
  border-radius: 0px;
  margin: 0px;
  /* width: 100%; */
  overflow-y: auto;
  max-height: 300px;
}

.dropdown-menu > .active,
.dropdown-menu > .active:focus,
.dropdown-menu > .active:hover {
  background-color: #00a1de;
  background-image: none;
}

.dropdown-menu > .active > a,
.dropdown-menu > .active > a:focus,
.dropdown-menu > .active > a:hover {
  background: none;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/angular.bootstrap.overrides.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB","sourcesContent":[".dropdown-menu {\n  border-radius: 0px;\n  margin: 0px;\n  /* width: 100%; */\n  overflow-y: auto;\n  max-height: 300px;\n}\n\n.dropdown-menu > .active,\n.dropdown-menu > .active:focus,\n.dropdown-menu > .active:hover {\n  background-color: #00a1de;\n  background-image: none;\n}\n\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:focus,\n.dropdown-menu > .active > a:hover {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
